module.exports = __webpack_public_path__ + "assets/img/list_titleImg (3).b3289b3f.png";